export function getMetricHistory<T>(
  metric: T[],
  scanNum: number = metric.length
) {
  return {
    cur: metric.at(metric.length - scanNum),
    prev: metric.at(metric.length - scanNum + 1),
  };
}
